import React, { Component } from 'react';

class TemplateNotFound extends Component {
  render(): JSX.Element {
    return <div>TemplateNotFound</div>;
  }
}

export default TemplateNotFound;
